import { useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { useLocation } from 'react-router'
import { CustomLink } from '../../../../common/CustomLink'
import { Element } from '../../../../common/html/element'
import {
  selectComponentAuthorized,
  selectUserType,
} from '../../../../layout/store/slice'
import { COMPONENTS } from '../../../../routers/constants'
import { AUTHORIZATION_TYPE } from '../../../../utils/authorization'
import { INDUSTRY_NEWS_TYPE_ID } from './constant'

export const ViewDetails = () => {
  const location = useLocation()

  const { organizationId } = new Proxy(new URLSearchParams(location.search), {
    get: (searchParam, prop) => searchParam.get(prop),
  })
  const userType = useSelector(selectUserType)
  const AUTHORIZATION_API = useSelector(selectComponentAuthorized)

  return (
    AUTHORIZATION_API.companyAnalysis.viewDetails[userType.userTypeId] ===
      AUTHORIZATION_TYPE.ALLOW && (
      <Element style={{ color: '#2C73E8' }}>
        <CustomLink
          target="_blank"
          to={
            COMPONENTS.companyAnalysis.components.newsAndSocials.route +
            `?organizationId=${organizationId}&newsTypeId=${INDUSTRY_NEWS_TYPE_ID}`
          }
        >
          <Translate value="industryOverview.recentNews.VIEW_DETAILS" />
        </CustomLink>
      </Element>
    )
  )
}
